const courseSettings = {
  language: "en",
  name: "Python Programming MOOC 2025",
  siteUrl: "https://programming-25.mooc.fi",
  githubUrl: "https://github.com/rage/programming-25",
  subtitle: "Python Programming MOOC",
  slug: "programming-25",
  organizationName: "MOOC",
  tmcCourse: "programming-25",
  quizzesId: "e0625f9b-626a-4941-afda-6c6e1b577045",
  tmcOrganization: "mooc",
  bannerPath: "banner.svg",
  showExerciseDescriptionWhenNotLoggedIn: true,
  courseVariants: [
    {
      tmcOrganization: "laurea",
      tmcCourse: "python-english-2025-laurea-henttonen",
    },
    {
      tmcOrganization: "laurea",
      tmcCourse: "python-english-2026-grotenfelt",
    },
    {
      tmcOrganization: "laurea",
      tmcCourse: "python-english-2026",
    },
  ],
}

module.exports = courseSettings
